import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import ReactOnRails from 'react-on-rails/client';

import EatApp from '../eat/EatApp';

const App = (props, railsContext, domNodeId) => {
  hydrateRoot(
    document.getElementById(domNodeId),
    React.createElement(
      EatApp,
      props,
    ),
  );
};

ReactOnRails.register({
  EatApp: App,
});
